module.exports = __webpack_public_path__ + "static/media/blindadosite.8411cd92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blindadosite.png
// module id = 37
// module chunks = 0